import '../../static/components/bootstrap-tagsinput/dist/bootstrap-tagsinput';
import '../../static/components/bootstrap-tagsinput/dist/bootstrap-tagsinput.css';

function formUnloadPrompt(formSelector, fieldSelector) {
  let formA;
  let formB;
  let formSubmit = false;

  if (fieldSelector) {
    formA = $(formSelector).find(fieldSelector).serialize();
  } else {
    formA = $(formSelector).serialize();
  }

  // Detect Form Submit
  $(formSelector).submit(function () {
    formSubmit = true;
  });

  // Handle Form Unload
  window.onbeforeunload = function () {
    if (formSubmit) return;
    if (fieldSelector) {
      formB = $(formSelector).find(fieldSelector).serialize();
    } else {
      formB = $(formSelector).serialize();
    }
    if (formA != formB) return 'Your changes have not been saved.';
  };
}

function initializetagInput(selector) {
  // fix tag-input placeholder: hide when there are at least one value inside:
  $(selector).on('itemAddedOnInit itemAdded', function (event) {
    $(this.previousSibling).find('input').attr('placeholder', '');
  });
  $(selector).on('itemRemoved', function (event) {
    if ($(this).val().length === 0) {
      $(this.previousSibling).find('input').attr('placeholder', $(this).attr('placeholder'));
    }
  });

  // initialize tag-input
  $(selector).tagsinput();
}

/* fix border highlight for chosen selects and tag inputs */
function inputFocusStyleFix() {
  $(document).on('focus', '.form-control .chosen-container .search-field input', function (e) {
    $(this).parents('.form-control').first().toggleClass('active', true);
  });
  $(document).on('blur', '.form-control .chosen-container .search-field input', function (e) {
    $(this).parents('.form-control').first().toggleClass('active', false);
  });
}

// this is a little hack to enable reloading the screen without alerting the user that their changes will be lost (which is required in some scenarios)
//
// persistFormChanges - saves the values of form (name passed) to localStorage
// rehydrateFormChanges - gets changes from localStorage and persist it in the DOM before removing the localStorage entry
//
// NOTE: Ideally you should persistFormChanges, reload the page and immediately rehydrateFormChanges
function persistFormChanges(formName) {
  const form = document.forms.namedItem(formName);

  if (form) {
    const supportedElements = ['text', 'number', 'email', 'url', 'radio', 'checkbox', 'range'].reduce(
      (result, type) => `${result}, [type=${type}]`,
      'select'
    );
    const elements = form.querySelectorAll(supportedElements);
    const state = [];

    elements.forEach(({ value, type, name, id, checked }) => {
      const identifierName = name ? `[name="${name}"]` : '';
      const identifierId = id ? `#${id}` : '';
      const identifierValue = type === 'radio' || type === 'checkbox' ? `[value="${value}"]` : '';

      state.push({
        value,
        type,
        identifier: `${identifierName}${identifierId}${identifierValue}`,
        checked
      });
    });

    const store = JSON.stringify(state.filter(({ identifier }) => identifier !== '')); // don't want empty id's what are you going to do with that???

    localStorage.setItem(formName, store);
  }
}

function rehydrateFormChanges(formName) {
  const storage = localStorage.getItem(formName);

  if (storage) {
    const changes = JSON.parse(storage);

    changes.forEach((item) => {
      const el = document.querySelector(item.identifier);
      if (el) {
        if (el.type === 'radio' || el.type === 'checkbox') {
          el.checked = item.checked;

          if (el.type === 'radio') {
            const parentEl = document.querySelector(item.identifier).closest('.radio');
            if (item.checked) {
              parentEl.classList.add('selected');
            } else {
              parentEl.classList.remove('selected');
            }
          }
        } else {
          el.value = item.value;
        }
      }
    });

    // remove from localStorage onces persisted in DOM to avoid strange behavior between projects
    localStorage.removeItem(formName);
  }
}

export { formUnloadPrompt, initializetagInput, inputFocusStyleFix, persistFormChanges, rehydrateFormChanges };
